import Nav from 'react-bootstrap/Nav'

export default function UtgNav(props) {
    
    return (
        <Nav variant="tabs" size="sm" activeKey={props.activeKey} className="px-3 my-3">
        <Nav.Item>
            <Nav.Link eventKey="1" href={`/be/${props.beId}/utgs/${props.componentId}`}>General</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="2" href={`/be/${props.beId}/utgs/${props.componentId}/apiinterfaces`}>API Interfaces</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="3" href={`/be/${props.beId}/utgs/${props.componentId}/devices`}>Devices</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="4" href={`/be/${props.beId}/utgs/${props.componentId}/config`}>Configuration</Nav.Link>
        </Nav.Item>
        </Nav>
    )
}